import { WordTypeScoreMO } from '../models/WordTypeScoreMO';
import { ChunkListMO } from '../models/ChunkListMO';
import { ChunkNodeMO } from '../models/ChunkNodeMO';
import { WordMO } from '../models/WordMO';

export class WordManager {
	private static getScore(score: number) {
		return Math.min(score || 0, 5);
	}

	static verifyScore(score) {
		return Math.min(Math.floor(score), 4);
	}

	static calculateAverage = (wordTypeScore: WordTypeScoreMO) => {
		let average = WordManager.verifyScore(
			Math.floor(
				(WordManager.getScore(wordTypeScore.nounScore) +
					WordManager.getScore(wordTypeScore.prepScore) +
					WordManager.getScore(wordTypeScore.verbScore) +
					WordManager.getScore(wordTypeScore.ad_Score) +
					WordManager.getScore(wordTypeScore.wasteScore)) /
					5,
			),
		);

		return average;
	};

	static onlyLetter(word: string) {
		return word.replace(/[^a-zA-Z]+/g, '');
	}

	static verifyWord(word: string) {
		return word.replace(/[’‘]+/g, "'").replace(/[”“]/, '"');
	}

	static isLetter(c: string) {
		if (c === null || c === undefined) {
			return false;
		}

		// match -> array
		// unmatch -> null
		return c.match(/[a-zA-Z]+/g) ? true : false;
	}

	static getWords(text: string) {
		// let start = 0;
		// let flag: boolean;
		let words: WordMO[] = [];
		let wc: number = 0;

		text.split(/\s/).forEach((term) => {
			if (term.length > 0) {
				words.push(new WordMO(term, false));
				wc++;
			}
		});

		return { words, wc };
	}

	static separateWord(text: string) {
		let start = 0;
		let flag: boolean = false;
		let words: string[] = [];

		if (text.length >= 0) {
			flag = WordManager.isLetter(text[0]);
		}

		for (let i = 0; i < text.length; i++) {
			const result = WordManager.isLetter(text[i]);

			if (flag !== result) {
				if (
					words.length >= 2 &&
					(words[words.length - 1] === "'" ||
						words[words.length - 1] === '’') &&
					this.isLetter(words[words.length - 2]) === true
				) {
					words[words.length - 1] = "'" + text.slice(start, i);
				} else {
					words.push(text.slice(start, i));
				}
				start = i;
				flag = result;
			}
		}

		if (start < text.length) {
			if (
				words.length >= 2 &&
				(words[words.length - 1] === "'" || words[words.length - 1] === '’') &&
				this.isLetter(words[words.length - 2]) === true
			) {
				words[words.length - 1] = "'" + text.slice(start, text.length);
			} else {
				words.push(text.slice(start, text.length));
			}
		}

		return words;
	}

	static seekChunk(
		chunkListMO: ChunkListMO,
		chunkTitle: string,
		chunkIndex: number,
	) {
		let temp: ChunkNodeMO = chunkListMO.head;
		let count = 0;

		while (temp !== null && temp.index < chunkIndex) {
			let paragraphs = temp.data.content;

			for (let i = 0; i < paragraphs.length; i++) {
				count += paragraphs[i].text.split(chunkTitle).length - 1;
			}

			temp = temp.next;
		}

		return count;
	}

	private static containsWord(string: string, word: string) {
		return new RegExp(`(^|[^a-zA-Z])${word}([^a-zA-Z]|$)`).test(string);
	}

	static seekWord(
		chunkListMO: ChunkListMO,
		chunkIdx: number,
		paragraphIdx: number,
		wordIdx: number,
		word: string,
	) {
		//
		let temp: ChunkNodeMO = chunkListMO.head;
		let count: number = 0;

		while (temp !== null && temp.index <= chunkIdx) {
			let paragraphs = temp.data.content;

			if (temp.index < chunkIdx) {
				for (let i = 0; i < paragraphs.length; i++) {
					const words = paragraphs[i].words;
					for (let k = 0; k < words.length; k++) {
						const wordMO = words[k];
						if (this.containsWord(wordMO.word, word)) {
							count += 1;
						}
					}
				}
			} else {
				for (let i = 0; i <= paragraphIdx; i++) {
					const words = paragraphs[i].words;

					let max = -1;
					if (i < paragraphIdx) {
						max = words.length;
					} else if (i === paragraphIdx) {
						max = wordIdx + 1;
					}

					for (let k = 0; k < max; k++) {
						const wordMO = words[k];
						if (this.containsWord(wordMO.word, word)) {
							count += 1;
						}
					}
				}
			}

			temp = temp.next;
		}

		return count;
	}
}
